"use strict";

import Vue from 'vue';
import axios from "axios";
import store from '../store';
import router from '../router'
import i18n from '../locale'
import { Message } from 'element-ui';

//axios.defaults.baseURL = 'http://cpaengine/yii2-app/partner/web';
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/api' : 'http://cpaengine/yii2-app/partner/web';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = 'Bearer ' + store().state.Auth.token;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: false, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {

      config.params = {'access-token': store().state.Auth.token, 'lang-id': i18n.locale};

      // const token = store().state.Auth.token;
      // if(token) {
      //     config.headers.common['authorization'] = `Bearer ${ token }`;
      // }

    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {

      if (!error.response) {
          Message.error('Неизвестная ошибка');
          return Promise.reject(error);
      }

      if (error.response.status === 429) {
          Message.warning(error.response.statusText);
      }

      if(error.response.status === 500) {
          Message.error(error.response.statusText);
      }

      if (error.response.status === 401) {
          //store().commit('resetToken');
          store().dispatch('logout');
          router.push({ path: '/login' })
      }


      if (error.response.status === 403) {
          if (error.response.data.code !== 0) {
              router.push({ name: 'activation' })
          } else {
              Message.error(error.response.data.message);
          }
      }

      if (error.response.status === 422) {
          //Message.warning('Проверьте данные формы');
          error.response.data = Object.assign(...error.response.data.map(d => ({[d.field]: d.message})));
      }

      if (error.response.status === 503) {
          window.location.href=window.location.href;
      }
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
